import {
    apiRequest,
    salaryP3KList,
    salaryP3KActive,
    salaryP3KInactive
} from "../../../../../services/adapters/master/salaryP3KService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", salaryP3KList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", salaryP3KInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", salaryP3KActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository